//
// DataSetDataProvider.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./RelationalDataProvider";
import "@sas-dvr/ltjs-commons/models/data/dataset/DataSet";

var DataSetDataProvider = createModule("gtl::DataSetDataProvider", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::DataProvider","gtl::RelationalDataProvider"], EventDispatcher, [
    ,
    {
        dataSet: 1,
    },
    ,
    ,
    {
        getName: [7],
    },
    {
        _create_v: [4],
        _create_o: [4,1],
    },
    ,
    ["_create"]
]);
export default DataSetDataProvider;
